import styled from 'styled-components';
import { rem } from 'styles/theme';

export const RewardsTableFigureStyled = styled.figure`
   img {
      max-width: ${rem(176)};
   }
`;
